export default __webpack_public_path__ + "static/media/email-verified-confetti.5af5fd47.svg";